import { render, staticRenderFns } from "./FintechDataRow.vue?vue&type=template&id=634252e6&"
import script from "./FintechDataRow.vue?vue&type=script&lang=js&"
export * from "./FintechDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports